import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.output.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set initial direction based on device language
try {
  const deviceLang = (typeof navigator !== 'undefined' && navigator.language)
    ? navigator.language.toLowerCase()
    : 'en';
  const isArabic = deviceLang.startsWith('ar');
  document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
  document.documentElement.lang = isArabic ? 'ar' : 'en';
} catch (_) {
  document.documentElement.dir = 'ltr';
  document.documentElement.lang = 'en';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
